import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { tikTokIcon } from "./icons/tiktok";
import { fbIcon } from "./icons/fb";
import { linkedinIcon } from "./icons/linkedin";
import { twitterIcon } from "./icons/twitter";
import { youtubeIcon } from "./icons/youtube";
import { instagramIcon } from "./icons/instagram";

@customElement("footer-socials")
export class FooterSocial extends LitElement {
  @property()
  theme = "white";

  override createRenderRoot() {
    return this;
  }

  override render() {
    return html`
      <div
        id="footer-social"
        class="lg:twf-pt-6 lg:twf-mt-8 lg:twf-border-t-[1px] lg:twf-grid-cols-12 lg:twf-gap-8 lg:twf-grid 2xl:twf-grid-cols-16 twf-px-4 md:twf-px-6 xl:twf-px-8 ${this
          .theme === "purple"
          ? "lg:twf-border-[#AD5DFC]"
          : "lg:twf-border-[#BDBDBD]"}"
      >
        <div
          class="twf-flex twf-mb-8 twf-w-60 twf-justify-between lg:twf-hidden "
        >
          <a
            id="titkok"
            target="_blank"
            href="https://www.tiktok.com/@cashrewardsaus"
            >${tikTokIcon(this.theme)}</a
          >
          <a
            id="instagram"
            target="_blank"
            href="https://www.instagram.com/cashrewardsau/"
            >${instagramIcon(this.theme)}</a
          >
          <a
            id="facebook"
            target="_blank"
            href="https://www.facebook.com/Cashrewards.com.au/"
            >${fbIcon(this.theme)}</a
          >
          <a
            id="linkedin"
            target="_blank"
            href="https://au.linkedin.com/company/cashrewards"
            >${linkedinIcon(this.theme)}</a
          >
          <a
            id="twitter"
            target="_blank"
            href="https://twitter.com/CashrewardsAU"
            >${twitterIcon(this.theme)}</a
          >
          <a
            target="_blank"
            href="https://www.youtube.com/@Cashrewardsaustralia"
            >${youtubeIcon(this.theme)}</a
          >
        </div>
        <div class="lg:twf-col-span-9 2xl:twf-col-span-12">
          <p
            class="twf-mb-8 twf-font-nunito twf-text-sm ${this.theme ===
            "purple"
              ? "twf-text-white"
              : "twf-text-[#282828]"}"
          >
            In the spirit of reconciliation, Cashrewards acknowledges the
            Traditional Custodians of country throughout Australia and their
            connections to land, sea and community. We pay our respect to their
            Elders past and present and extend that respect to all Aboriginal
            and Torres Strait Islander peoples today.
          </p>
          <p
            class="twf-text-sm twf-pb-8 lg:twf-pb-6 ${this.theme === "purple"
              ? "twf-text-white"
              : "twf-text-[#282828]"}"
          >
            Copyright © 2023 Cashrewards
          </p>
        </div>
        <div
          class="twf-hidden twf-mb-8 twf-w-[216px] twf-justify-between lg:twf-flex lg:twf-ml-auto lg:twf-col-span-3 2xl:twf-col-span-4"
        >
          <a
            id="titkok"
            target="_blank"
            href="https://www.tiktok.com/@cashrewardsaus"
            >${tikTokIcon(this.theme)}</a
          >
          <a
            id="instagram"
            target="_blank"
            href="https://www.instagram.com/cashrewardsau/"
            >${instagramIcon(this.theme)}</a
          >
          <a
            id="facebook"
            target="_blank"
            href="https://www.facebook.com/Cashrewards.com.au/"
            >${fbIcon(this.theme)}</a
          >
          <a
            id="linkedin"
            target="_blank"
            href="https://au.linkedin.com/company/cashrewards"
            >${linkedinIcon(this.theme)}</a
          >
          <a
            id="twitter"
            target="_blank"
            href="https://twitter.com/CashrewardsAU"
            >${twitterIcon(this.theme)}</a
          >
          <a
            target="_blank"
            href="https://www.youtube.com/@Cashrewardsaustralia"
            >${youtubeIcon(this.theme)}</a
          >
        </div>
      </div>
    `;
  }
}
